import React, { Component } from 'react';
import { connect } from 'react-redux';
import OutsideClickHandler from 'react-outside-click-handler';
import { login } from './../../actions/globalActions';
import './css/index.scss';

class Login extends Component {
  
  constructor(props){
    super(props);
    this.state = {
      showLoader: false,
      user: '',
      pass: '',
    };
  }

  render () {
    return (
        <OutsideClickHandler
        onOutsideClick={() => {
            this.props.hideLogin();
        }} 
      >
        <div className="login-box">
            <form method="post" action="" onSubmit={(event)=>{
                            event.preventDefault(); // Let's stop this event.
                            event.stopPropagation(); // Really this time.
                        }}>
            <div>
                {this.props.loginErrors !== null && this.props.loginErrors.email !== undefined ? <div className="error-text">{this.props.loginErrors.email.join(' ')}</div> : null}        
                <input type="text" name="taburiEmail" onChange={(e)=>{this.setState({user: e.target.value})}} value={this.state.user} placeholder="email" />
            </div>
            <div>
                {this.props.loginErrors !== null && this.props.loginErrors.password !== undefined ? <div className="error-text">{this.props.loginErrors.password.join(' ')}</div> : null}        
                <input autoComplete="off" type="password" name="taburiPass" onChange={(e)=>{this.setState({pass: e.target.value})}} value={this.state.pass} placeholder="parolă" />
            </div>
            <div>
                {this.props.loginErrors !== null && this.props.loginErrors.error !== undefined ? <div className="error-text-2">{this.props.loginErrors.error}</div> : null}        
                <button onClick={()=>{this.props.login(this.state.user, this.state.pass)}}>Autentificare</button>
            </div>
            <div>
               <p style={{textAlign: 'center'}}>SAU dacă nu ai cont</p>
            </div>
            <div>
               <button onClick={()=>{window.location = '/cont-nou';}}>Creează Cont Nou</button>
            </div>
            </form>
        </div>
        </OutsideClickHandler>
    );
  }
};

const mapStateToProps = state => {
    return {
      loginErrors: state.global.get('loginErrors')
    };
  };
  
  const mapDispatchProps = dispatch => {
    return {
      login: (user, pass) => {
        dispatch(login(user, pass));
      },
    }
  };

export default connect(mapStateToProps, mapDispatchProps)(Login);



// WEBPACK FOOTER //
// ./src/components/login/login.js